export { default as EN } from "./en.json";
export const SUBSIDIZERS_TRANSLATIONS_NAMESPACE = "subsidizers";
